// Category accent colors per HorseAppCompare brand guidelines.
export const CATEGORY_COLORS = {
  training: "#10B981",
  health: "#7C3AED",
  nutrition: "#F59E0B",
  competitions: "#2563EB",
  breeding: "#EC4899",
  stable: "#0891B2",
  professional: "#64748B",
  safety: "#EF4444",
  ai: "#6366F1",
};

export const categoryColor = (key) => CATEGORY_COLORS[key] || "#2563EB";
